import React from "react";
import "./Header.css";

import HeaderLogo from "../../assets/header.jpg";

const Header = () => {
  return (
    <>
      <img
        className="delicious100-interactive__header"
        src={HeaderLogo}
        alt="HeaderLogo"
      ></img>
    </>
  );
};

export default Header;
